/**
 * THETA FOUNDRY — Elite HYROX Coaching Landing Page
 * Asset: theta-foundry.js
 *
 * Upload to your Shopify theme's /assets/ directory.
 * Auto-loaded by the section liquid file.
 */

(function () {
  "use strict";

  // ============================================================
  // COACH DATA
  // ============================================================
  var COACHES = {
    ben: {
      name: "BEN SUTHERLAND",
      tag: "World Record Holder &middot; Capacity Specialist",
      bio: "World record breaker. Specialising in base building and race tapering. Ben builds programmes around your race calendar, physiology, and how you respond to training load.",
      spots: 4,
      price: "&pound;450/mo",
      stats: [
        { val: "11+", lbl: "World Records" },
        { val: "Elite15", lbl: "Podiums" },
        { val: "Sub-55", lbl: "Best HYROX time" },
        { val: "200+", lbl: "Athletes coached" },
      ],
    },
    harry: {
      name: "HARRY SUTHERLAND",
      tag: "World Record Holder &middot; Elite15 Specialist",
      bio: "Former multi-eventer and current armed service member. Focuses on improving an athlete's aerobic base and race capacity.",
      spots: 0,
      price: "&pound;450/mo",
      stats: [
        { val: "5+", lbl: "World Records" },
        { val: "Elite15", lbl: "Podium Finishes" },
        { val: "Sub-57", lbl: "Best HYROX Time" },
        { val: "Top 3%", lbl: "Global Ranking" },
      ],
    },
    george: {
      name: "GEORGE WOOTTEN",
      tag: "World Record Holder &middot; Executive Specialist",
      bio: "Relay world record breaker. Ex-professional rugby player. Specialist in strength training and conditioning. Rebuilding athletes from the ground up.",
      spots: 7,
      price: "&pound;550/mo",
      stats: [
        { val: "WR", lbl: "Relay World Record" },
        { val: "Sub-58", lbl: "Best HYROX Time" },
        { val: "8yr", lbl: "Elite Competition" },
        { val: "100+", lbl: "Athletes Coached" },
      ],
    },
  };

  // ============================================================
  // QUIZ DATA
  // ============================================================
  var QUIZ_QUESTIONS = {
    experience: {
      id: "experience",
      category: "EXPERIENCE",
      text: "How many HYROX races have you completed?",
      options: [
        { label: "None", sub: "I'm signing up for my first", score: 1 },
        {
          label: "1&ndash;2 races",
          sub: "Focused on finishing or beating my first time",
          score: 2,
        },
        { label: "3&ndash;5 races", sub: "Chasing consistent PBs", score: 3 },
        {
          label: "6+ races",
          sub: "Competing for podiums or Elite15",
          score: 4,
        },
      ],
    },
    benchmark: {
      id: "benchmark",
      category: "BENCHMARK",
      text: "What's your HYROX time benchmark?",
      detail:
        "If you've raced, use your best time. If not, pick your honest target.",
      options: [
        {
          label: "No target yet &mdash; just finish",
          sub: "First race, outcome open",
          score: 1,
        },
        {
          label: "90 min+ / targeting sub-90",
          sub: "Building towards a solid first result",
          score: 2,
        },
        {
          label: "60&ndash;90 min / targeting sub-75",
          sub: "Competitive age-group territory",
          score: 3,
        },
        {
          label: "Sub-60 / targeting Elite15",
          sub: "Racing at the sharp end",
          score: 4,
        },
      ],
    },
    splits: {
      id: "splits",
      category: "RUNNING",
      text: "What are your 1km run splits during a HYROX race?",
      detail:
        "HYROX features 8 &times; 1km runs. Your lap split &mdash; not your fresh 5km pace &mdash; is the number that matters.",
      options: [
        {
          label: "Under 4:00 /km",
          sub: "Holding sub-4 across most laps",
          score: 4,
        },
        {
          label: "4:00&ndash;5:00 /km",
          sub: "Solid race runner, pace holds well",
          score: 3,
        },
        {
          label: "5:00&ndash;6:30 /km",
          sub: "Running slows significantly under fatigue",
          score: 2,
        },
        {
          label: "I don't know my race splits",
          sub: "Use my 5km running pace instead",
          score: 0,
          branch: "pace",
        },
      ],
    },
    pace: {
      id: "pace",
      category: "RUNNING",
      text: "What's your current 5km running pace?",
      detail:
        "Fresh, not race-fatigued &mdash; your honest standalone 5km time.",
      options: [
        {
          label: "Sub-20 min",
          sub: "Under 4:00/km &mdash; strong running base",
          score: 4,
        },
        {
          label: "20&ndash;24 min",
          sub: "4:00&ndash;4:48/km &mdash; solid aerobic engine",
          score: 3,
        },
        {
          label: "24&ndash;30 min",
          sub: "4:48&ndash;6:00/km &mdash; building the base",
          score: 2,
        },
        {
          label: "30+ min",
          sub: "Over 6:00/km &mdash; foundation work needed",
          score: 1,
        },
      ],
    },
    volume: {
      id: "volume",
      category: "VOLUME",
      text: "How many structured training sessions do you complete per week?",
      options: [
        { label: "1&ndash;3 sessions", sub: "Building consistency", score: 1 },
        { label: "4&ndash;5 sessions", sub: "General fitness focus", score: 2 },
        {
          label: "5&ndash;6 sessions",
          sub: "Structured programming",
          score: 3,
        },
        {
          label: "6+ sessions",
          sub: "Race-specific training blocks",
          score: 4,
        },
      ],
    },
    weakness: {
      id: "weakness",
      category: "WEAKNESS",
      text: "Where do you lose the most ground in a HYROX race?",
      detail:
        "Be honest &mdash; this shapes your phase focus more than anything else.",
      options: [
        {
          label: "The 1km runs",
          sub: "My splits deteriorate badly across 8 laps. Running base is the limiter.",
          score: 1,
        },
        {
          label: "The stations",
          sub: "Ski erg, sled, wall balls, burpee broad jumps. I lose significant time on the floor.",
          score: 2,
        },
        {
          label: "Race pacing",
          sub: "I go out too hard and blow up by lap 4 or 5",
          score: 3,
        },
        {
          label: "The final 2 laps",
          sub: "Transitions and the last push. Hard to execute under that level of fatigue.",
          score: 4,
        },
      ],
    },
  };

  var QUIZ_DEFAULT_FLOW = [
    "experience",
    "benchmark",
    "splits",
    "volume",
    "weakness",
  ];

  var QUIZ_RESULTS = {
    1: {
      phase: "PHASE 01",
      title: "STRUCTURE",
      headline: "You start with the chassis.",
      summary:
        "Foundation comes first. Before you can race fast, you need to move well, run efficiently, and build the durability to handle real training load. Skipping this stage is why most athletes stall.",
      focus: [
        "Movement quality and running mechanics",
        "Aerobic base and tissue tolerance",
        "Injury resilience and recovery capacity",
      ],
    },
    2: {
      phase: "PHASE 02",
      title: "STRENGTH",
      headline: "You're ready to handle volume.",
      summary:
        "Your aerobic base is there. Now we build the capacity to hold output across all eight stations without dropping. This is where race strength comes from. Not gym strength.",
      focus: [
        "Threshold work and power under fatigue",
        "Muscular endurance across all stations",
        "Capacity to hold pace through the final 2km",
      ],
    },
    3: {
      phase: "PHASE 03",
      title: "SPEED",
      headline: "You sharpen for execution.",
      summary:
        "Your engine is built. Now we sharpen it for race day. Pacing, transitions, race simulation, and the specific work to hold your best performance when it counts.",
      focus: [
        "Race simulation and pacing models",
        "Transition speed and cognitive efficiency",
        "Peak performance timing and taper",
      ],
      showBespoke: true,
    },
  };

  function calcPhase(scores) {
    var total = scores.reduce(function (a, b) {
      return a + b;
    }, 0);
    if (total <= 9) return 1;
    if (total <= 14) return 2;
    return 3;
  }

  // ============================================================
  // SMOOTH SCROLL UTILITY
  // ============================================================
  function smoothScrollTo(targetId) {
    var target = document.getElementById(targetId);
    if (!target) return;
    var nav = document.getElementById("tf-nav");
    var navHeight = nav ? nav.offsetHeight : 0;
    var top =
      target.getBoundingClientRect().top + window.pageYOffset - navHeight - 16;
    window.scrollTo({ top: top, behavior: "smooth" });
  }

  function bindScrollLinks(container) {
    var btns = container
      ? container.querySelectorAll("[data-scroll-to]")
      : document.querySelectorAll("[data-scroll-to]");
    btns.forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        var targetId = this.getAttribute("data-scroll-to");
        var startQuiz = this.getAttribute("data-start-quiz");
        smoothScrollTo(targetId);
        if (startQuiz) {
          setTimeout(function () {
            var beginBtn = document.getElementById("tf-quiz-begin");
            if (beginBtn) beginBtn.click();
          }, 800);
        }
        var selectCoach = this.getAttribute("data-select-coach");
        if (selectCoach) {
          setTimeout(function () {
            var pricingBtn = document.querySelector(
              '[data-pricing-coach="' + selectCoach + '"]',
            );
            if (pricingBtn) pricingBtn.click();
          }, 800);
        }
      });
    });
  }

  // ============================================================
  // SCROLL ANIMATION
  // ============================================================
  function initScrollAnimations() {
    var animatedEls = document.querySelectorAll(".tf-animate");
    if (!animatedEls.length) return;

    if (!("IntersectionObserver" in window)) {
      animatedEls.forEach(function (el) {
        el.classList.add("is-visible");
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: "0px 0px -40px 0px" },
    );

    animatedEls.forEach(function (el) {
      observer.observe(el);
    });
  }

  // ============================================================
  // STICKY NAV
  // ============================================================
  function initStickyNav() {
    var nav = document.getElementById("tf-nav");
    if (!nav) return;
    function onScroll() {
      nav.classList.toggle("is-scrolled", window.scrollY > 60);
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  // ============================================================
  // COACHES — interactive selection + detail panel
  // ============================================================
  function initCoaches() {
    var tabs = document.querySelectorAll(".tf-coach-tab");
    var detail = document.getElementById("tf-coach-detail");
    var section = document.getElementById("tf-coaches");
    if (!tabs.length || !detail) return;

    var bespokeUrl = section
      ? section.getAttribute("data-bespoke-url") || "#"
      : "#";

    function renderDetail(coachId) {
      var c = COACHES[coachId];
      if (!c) return;

      var available = c.spots > 0;

      var statsHtml = "";
      if (c.stats && c.stats.length) {
        statsHtml = '<div class="tf-cd-stats">';
        c.stats.forEach(function (s) {
          statsHtml +=
            '<div class="tf-cd-stat"><div class="tf-cd-stat__val">' +
            s.val +
            '</div><div class="tf-cd-stat__lbl">' +
            s.lbl +
            "</div></div>";
        });
        statsHtml += "</div>";
      }

      var dotClass = available ? "tf-avail-dot--open" : "tf-avail-dot--full";
      var availText = available
        ? c.spots + " spots available"
        : "Currently full";

      var enrollBtn = available
        ? '<a href="#tf-pricing" class="tf-btn tf-btn--primary tf-cd__enrol" data-scroll-to="tf-pricing" data-select-coach="' +
          coachId +
          '">ENROL &mdash; ' +
          c.price +
          "</a>"
        : '<button class="tf-btn tf-btn--ghost tf-cd__enrol" disabled aria-disabled="true" style="opacity:0.35;cursor:not-allowed">CURRENTLY FULL</button>';

      detail.innerHTML =
        '<div class="tf-cd">' +
        '<div class="tf-cd__left">' +
        '<div class="tf-cd__tag">' +
        c.tag +
        "</div>" +
        '<p class="tf-cd__bio">' +
        c.bio +
        "</p>" +
        statsHtml +
        "</div>" +
        '<div class="tf-cd__right">' +
        '<div class="tf-cd__meta">' +
        '<div class="tf-cd__price">' +
        c.price +
        "</div>" +
        '<div class="tf-cd__avail"><span class="tf-avail-dot ' +
        dotClass +
        '"></span>' +
        availText +
        "</div>" +
        "</div>" +
        '<div class="tf-cd__actions">' +
        enrollBtn +
        '<a href="' +
        bespokeUrl +
        '" target="_blank" rel="noopener noreferrer" class="tf-btn tf-btn--ghost">REQUEST ELITE CONSULT</a>' +
        "</div>" +
        "</div>" +
        "</div>";

      bindScrollLinks(detail);
    }

    // Override hardcoded spots with live values from data-spots attributes
    tabs.forEach(function (tab) {
      var coachId = tab.getAttribute("data-coach");
      var spotsAttr = tab.getAttribute("data-spots");
      if (coachId && spotsAttr !== null && COACHES[coachId]) {
        COACHES[coachId].spots = parseInt(spotsAttr, 10);
      }
    });

    var openMobileCoach = null;

    function isMobile() {
      return window.innerWidth <= 768;
    }

    function removeMobileAccordion() {
      var existing = document.querySelector(".tf-coach-accordion");
      if (existing) existing.parentNode.removeChild(existing);
    }

    function renderMobileAccordion(coachId, afterEl) {
      var c = COACHES[coachId];
      if (!c) return;
      var available = c.spots > 0;
      var statsHtml = "";
      if (c.stats && c.stats.length) {
        statsHtml = '<div class="tf-cd-stats">';
        c.stats.forEach(function (s) {
          statsHtml +=
            '<div class="tf-cd-stat"><div class="tf-cd-stat__val">' +
            s.val +
            '</div><div class="tf-cd-stat__lbl">' +
            s.lbl +
            "</div></div>";
        });
        statsHtml += "</div>";
      }
      var dotClass = available ? "tf-avail-dot--open" : "tf-avail-dot--full";
      var availText = available
        ? c.spots + " spots available"
        : "Currently full";
      var enrollBtn = available
        ? '<a href="#tf-pricing" class="tf-btn tf-btn--primary tf-cd__enrol" data-scroll-to="tf-pricing" data-select-coach="' +
          coachId +
          '" style="width:100%;justify-content:center">ENROL &mdash; ' +
          c.price +
          "</a>"
        : '<button class="tf-btn tf-btn--ghost tf-cd__enrol" disabled aria-disabled="true" style="opacity:0.35;cursor:not-allowed;width:100%;justify-content:center">CURRENTLY FULL</button>';
      var accordion = document.createElement("div");
      accordion.className = "tf-coach-accordion";
      accordion.innerHTML =
        '<div class="tf-cd">' +
        '<div class="tf-cd__left">' +
        '<div class="tf-cd__tag">' +
        c.tag +
        "</div>" +
        '<p class="tf-cd__bio">' +
        c.bio +
        "</p>" +
        statsHtml +
        "</div>" +
        '<div class="tf-cd__right">' +
        '<div class="tf-cd__meta">' +
        '<div class="tf-cd__price">' +
        c.price +
        "</div>" +
        '<div class="tf-cd__avail"><span class="tf-avail-dot ' +
        dotClass +
        '"></span>' +
        availText +
        "</div>" +
        "</div>" +
        '<div class="tf-cd__actions">' +
        enrollBtn +
        '<a href="' +
        bespokeUrl +
        '" target="_blank" rel="noopener noreferrer" class="tf-btn tf-btn--ghost" style="width:100%;justify-content:center">REQUEST ELITE CONSULT</a>' +
        "</div>" +
        "</div>" +
        "</div>";
      afterEl.parentNode.insertBefore(accordion, afterEl.nextSibling);
      bindScrollLinks(accordion);
    }

    var openDesktopCoach = null;

    tabs.forEach(function (tab) {
      tab.addEventListener("click", function () {
        var coachId = this.getAttribute("data-coach");

        if (isMobile()) {
          if (openMobileCoach === coachId) {
            removeMobileAccordion();
            openMobileCoach = null;
            this.classList.remove("is-selected");
            this.setAttribute("aria-pressed", "false");
          } else {
            removeMobileAccordion();
            tabs.forEach(function (t) {
              t.classList.remove("is-selected");
              t.setAttribute("aria-pressed", "false");
            });
            this.classList.add("is-selected");
            this.setAttribute("aria-pressed", "true");
            renderMobileAccordion(coachId, this);
            openMobileCoach = coachId;
          }
        } else {
          removeMobileAccordion();
          openMobileCoach = null;
          if (openDesktopCoach === coachId) {
            detail.innerHTML = "";
            openDesktopCoach = null;
            tabs.forEach(function (t) {
              t.classList.remove("is-selected");
              t.setAttribute("aria-pressed", "false");
            });
          } else {
            tabs.forEach(function (t) {
              t.classList.remove("is-selected");
              t.setAttribute("aria-pressed", "false");
            });
            this.classList.add("is-selected");
            this.setAttribute("aria-pressed", "true");
            renderDetail(coachId);
            openDesktopCoach = coachId;
          }
        }
      });
    });
  }

  // ============================================================
  // QUIZ — phase placement
  // ============================================================
  function initQuiz() {
    var wrap = document.getElementById("tf-quiz-wrap");
    if (!wrap) return;

    var section = document.getElementById("tf-coaches");
    var bespokeUrl = section
      ? section.getAttribute("data-bespoke-url") || "#"
      : "#";

    var state = {
      flow: QUIZ_DEFAULT_FLOW.slice(),
      current: 0,
      scores: [],
      selected: null,
      selectedBranch: null,
      result: null,
    };

    function renderStart() {
      wrap.innerHTML =
        '<div class="tf-quiz">' +
        '<div class="tf-quiz-start">' +
        '<span class="tf-quiz-badge">PHASE PLACEMENT</span>' +
        '<h3 class="tf-quiz-start__title">Find Your Starting Phase</h3>' +
        '<p class="tf-quiz-start__sub">Not everyone starts at Phase 1. Answer 5 questions &mdash; we\'ll place you exactly where your training should begin.</p>' +
        '<div class="tf-quiz-start__meta">' +
        "<div><strong>5</strong> questions</div>" +
        "<div><strong>&lt;2</strong> minutes</div>" +
        "<div><strong>1</strong> precise result</div>" +
        "</div>" +
        '<button class="tf-btn tf-btn--primary tf-btn--lg" id="tf-quiz-begin">FIND MY PHASE</button>' +
        "</div>" +
        "</div>";

      document
        .getElementById("tf-quiz-begin")
        .addEventListener("click", function () {
          state.flow = QUIZ_DEFAULT_FLOW.slice();
          state.current = 0;
          state.scores = [];
          state.selected = null;
          state.selectedBranch = null;
          state.result = null;
          renderQuestion();
        });
    }

    function renderQuestion() {
      var q = QUIZ_QUESTIONS[state.flow[state.current]];
      var total = state.flow.length;
      var progress = (state.current / total) * 100;

      var detailHtml = q.detail
        ? '<p class="tf-quiz-q__detail">' + q.detail + "</p>"
        : "";

      var optionsHtml = '<div class="tf-quiz-opts">';
      q.options.forEach(function (opt) {
        var isSelected =
          state.selected === opt.score &&
          state.selectedBranch === (opt.branch || null);
        var subHtml = opt.sub
          ? '<div class="tf-quiz-opt__sub">' + opt.sub + "</div>"
          : "";
        optionsHtml +=
          '<button class="tf-quiz-opt' +
          (isSelected ? " is-selected" : "") +
          '"' +
          ' data-score="' +
          opt.score +
          '"' +
          ' data-branch="' +
          (opt.branch || "") +
          '">' +
          '<div class="tf-quiz-opt__label">' +
          opt.label +
          "</div>" +
          subHtml +
          "</button>";
      });
      optionsHtml += "</div>";

      var backHtml =
        state.current > 0
          ? '<button class="tf-quiz-nav__back" id="tf-quiz-back">&larr; BACK</button>'
          : "<div></div>";

      var isLastQ = state.current + 1 === total;
      var nextLabel = state.selectedBranch
        ? "NEXT"
        : isLastQ
          ? "SEE MY PHASE"
          : "NEXT";
      var nextDisabled = state.selected === null;

      wrap.innerHTML =
        '<div class="tf-quiz">' +
        '<div class="tf-quiz-progress"><div class="tf-quiz-progress__bar" style="width:' +
        progress +
        '%"></div></div>' +
        '<div class="tf-quiz-header">' +
        '<span class="tf-quiz-header__cat">' +
        q.category +
        "</span>" +
        '<span class="tf-quiz-header__count">' +
        (state.current + 1) +
        " / " +
        total +
        "</span>" +
        "</div>" +
        '<div class="tf-quiz-body">' +
        '<h3 class="tf-quiz-q__text">' +
        q.text +
        "</h3>" +
        detailHtml +
        optionsHtml +
        '<div class="tf-quiz-nav">' +
        backHtml +
        '<button class="tf-btn tf-btn--primary' +
        (nextDisabled ? " tf-btn--disabled" : "") +
        '"' +
        ' id="tf-quiz-next"' +
        (nextDisabled ? " disabled" : "") +
        ">" +
        nextLabel +
        "</button>" +
        "</div>" +
        "</div>" +
        "</div>";

      wrap.querySelectorAll(".tf-quiz-opt").forEach(function (btn) {
        btn.addEventListener("click", function () {
          state.selected = parseInt(this.getAttribute("data-score"), 10);
          state.selectedBranch = this.getAttribute("data-branch") || null;
          renderQuestion();
        });
      });

      var backBtn = document.getElementById("tf-quiz-back");
      if (backBtn) {
        backBtn.addEventListener("click", function () {
          state.current--;
          state.selected =
            state.scores[state.current] !== undefined
              ? state.scores[state.current]
              : null;
          state.scores = state.scores.slice(0, state.current);
          state.selectedBranch = null;
          renderQuestion();
        });
      }

      var nextBtn = document.getElementById("tf-quiz-next");
      if (nextBtn) {
        nextBtn.addEventListener("click", function () {
          if (state.selected === null) return;

          if (state.selectedBranch) {
            var newFlow = state.flow.slice();
            newFlow[state.current] = state.selectedBranch;
            state.flow = newFlow;
            state.selected = null;
            state.selectedBranch = null;
            renderQuestion();
            return;
          }

          state.scores.push(state.selected);

          if (state.current + 1 < state.flow.length) {
            state.current++;
            state.selected = null;
            state.selectedBranch = null;
            renderQuestion();
          } else {
            state.result = calcPhase(state.scores);
            renderResult();
          }
        });
      }
    }

    function renderResult() {
      var r = QUIZ_RESULTS[state.result];

      var focusHtml = "";
      r.focus.forEach(function (f, i) {
        focusHtml +=
          '<div class="tf-qr-focus-item">' +
          '<span class="tf-qr-focus-num">0' +
          (i + 1) +
          "</span>" +
          "<p>" +
          f +
          "</p>" +
          "</div>";
      });

      var phasesHtml = '<div class="tf-qr-phases">';
      [1, 2, 3].forEach(function (p) {
        phasesHtml +=
          '<div class="tf-qr-phase' +
          (p === state.result ? " is-active" : "") +
          '">' +
          QUIZ_RESULTS[p].title +
          "</div>";
      });
      phasesHtml += "</div>";

      var bespokeHtml = r.showBespoke
        ? '<a href="' +
          bespokeUrl +
          '" target="_blank" rel="noopener noreferrer" class="tf-btn tf-btn--ghost">OR REQUEST AN ELITE CONSULT</a>'
        : "";

      wrap.innerHTML =
        '<div class="tf-quiz tf-quiz--result">' +
        '<div class="tf-qr-header">' +
        '<span class="tf-quiz-badge">YOUR PHASE PLACEMENT</span>' +
        '<button class="tf-qr-retake" id="tf-quiz-retake">RETAKE</button>' +
        "</div>" +
        '<div class="tf-qr-body">' +
        '<div class="tf-qr-left">' +
        '<div class="tf-qr-phase-label">' +
        r.phase +
        "</div>" +
        '<h3 class="tf-qr-title">' +
        r.title +
        "</h3>" +
        '<p class="tf-qr-headline">' +
        r.headline +
        "</p>" +
        '<p class="tf-qr-summary">' +
        r.summary +
        "</p>" +
        '<div class="tf-qr-actions">' +
        '<a href="#tf-pricing" class="tf-btn tf-btn--primary" data-scroll-to="tf-pricing">Enroll now.</a>' +
        bespokeHtml +
        "</div>" +
        "</div>" +
        '<div class="tf-qr-right">' +
        '<p class="tf-qr-label">YOUR TRAINING FOCUS</p>' +
        '<div class="tf-qr-focus">' +
        focusHtml +
        "</div>" +
        '<div class="tf-qr-all-phases">' +
        '<p class="tf-qr-label">ALL THREE PHASES</p>' +
        phasesHtml +
        "</div>" +
        '<p class="tf-qr-note">We\'ll confirm your phase placement after reviewing your application, including any footage or performance data you submit. Your programme starts within 48 hours of approval.</p>' +
        "</div>" +
        "</div>" +
        "</div>";

      bindScrollLinks(wrap);

      document
        .getElementById("tf-quiz-retake")
        .addEventListener("click", function () {
          state.flow = QUIZ_DEFAULT_FLOW.slice();
          state.current = 0;
          state.scores = [];
          state.selected = null;
          state.selectedBranch = null;
          state.result = null;
          renderStart();
        });
    }

    renderStart();
  }

  // ============================================================
  // PRICING COACH SELECTOR
  // ============================================================
  function initPricingTabs() {
    var tabs = document.querySelectorAll(".tf-ptab");
    var grid = document.querySelector(".tf-pricing__grid");
    var cards = grid ? grid.querySelectorAll(":scope > .tf-pricing-card") : [];
    if (!tabs.length || !cards.length) return;

    var tierOrder = ["core", "performance", "bespoke"];
    var tierIndex = { core: 0, performance: 1, bespoke: 2 };
    var current = 0;

    function setActive(idx) {
      current = ((idx % cards.length) + cards.length) % cards.length;
      var tier = tierOrder[current];
      tabs.forEach(function (t) {
        var on = t.getAttribute("data-tier") === tier;
        t.classList.toggle("is-active", on);
        t.setAttribute("aria-selected", on ? "true" : "false");
      });
      var n = cards.length;
      var prev = (current - 1 + n) % n;
      var next = (current + 1) % n;
      cards.forEach(function (card, i) {
        card.classList.remove("is-active-tier", "is-prev-tier", "is-next-tier");
        if (i === current) card.classList.add("is-active-tier");
        else if (i === prev) card.classList.add("is-prev-tier");
        else if (i === next) card.classList.add("is-next-tier");
      });
    }

    function activateTier(tier) {
      var idx = tierIndex[tier] != null ? tierIndex[tier] : 0;
      setActive(idx);
    }

    tabs.forEach(function (tab) {
      tab.addEventListener("click", function () {
        activateTier(this.getAttribute("data-tier"));
      });
    });

    // Click side cards to bring them into focus
    cards.forEach(function (card, i) {
      card.addEventListener("click", function (e) {
        if (card.classList.contains("is-prev-tier")) {
          e.preventDefault();
          setActive(current - 1);
        } else if (card.classList.contains("is-next-tier")) {
          e.preventDefault();
          setActive(current + 1);
        }
      }, true);
    });

    // Touch swipe support
    if (grid) {
      var startX = 0, startY = 0, tracking = false;
      grid.addEventListener("touchstart", function (e) {
        if (!e.touches || !e.touches[0]) return;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        tracking = true;
      }, { passive: true });
      grid.addEventListener("touchend", function (e) {
        if (!tracking) return;
        tracking = false;
        var t = (e.changedTouches && e.changedTouches[0]) || null;
        if (!t) return;
        var dx = t.clientX - startX;
        var dy = t.clientY - startY;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          if (dx < 0) setActive(current + 1);
          else setActive(current - 1);
        }
      }, { passive: true });
    }

    // Default to Foundry Performance
    activateTier("performance");
  }

  // ============================================================
  // COACHES COVERFLOW CAROUSEL
  // ============================================================
  function initCoachesCarousel() {
    var pills = document.querySelectorAll(".tf-coach-pill");
    var grid = document.querySelector(".tf-coaches__grid");
    var cards = grid ? grid.querySelectorAll(":scope > .tf-coach-card") : [];
    if (!pills.length || !cards.length) return;

    var coachOrder = [];
    cards.forEach(function (c) { coachOrder.push(c.getAttribute("data-coach")); });
    var current = 0;

    function setActive(idx) {
      current = ((idx % cards.length) + cards.length) % cards.length;
      var coach = coachOrder[current];
      pills.forEach(function (p) {
        var on = p.getAttribute("data-coach") === coach;
        p.classList.toggle("is-active", on);
        p.setAttribute("aria-selected", on ? "true" : "false");
      });
      var n = cards.length;
      var prev = (current - 1 + n) % n;
      var next = (current + 1) % n;
      cards.forEach(function (card, i) {
        card.classList.remove("is-active-coach", "is-prev-coach", "is-next-coach");
        if (i === current) card.classList.add("is-active-coach");
        else if (i === prev) card.classList.add("is-prev-coach");
        else if (i === next) card.classList.add("is-next-coach");
      });
    }

    function activateCoach(coach) {
      var idx = coachOrder.indexOf(coach);
      setActive(idx >= 0 ? idx : 0);
    }

    pills.forEach(function (pill) {
      pill.addEventListener("click", function () {
        activateCoach(this.getAttribute("data-coach"));
      });
    });

    cards.forEach(function (card) {
      card.addEventListener("click", function (e) {
        if (card.classList.contains("is-prev-coach")) {
          e.preventDefault();
          setActive(current - 1);
        } else if (card.classList.contains("is-next-coach")) {
          e.preventDefault();
          setActive(current + 1);
        }
      }, true);
    });

    var startX = 0, startY = 0, tracking = false;
    grid.addEventListener("touchstart", function (e) {
      if (!e.touches || !e.touches[0]) return;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      tracking = true;
    }, { passive: true });
    grid.addEventListener("touchend", function (e) {
      if (!tracking) return;
      tracking = false;
      var t = (e.changedTouches && e.changedTouches[0]) || null;
      if (!t) return;
      var dx = t.clientX - startX;
      var dy = t.clientY - startY;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
        if (dx < 0) setActive(current + 1);
        else setActive(current - 1);
      }
    }, { passive: true });

    // Default to Ben
    activateCoach("ben");
  }

  function initPricingCoachSelector() {
    var btns = document.querySelectorAll("[data-pricing-coach]");
    var forms = document.querySelectorAll(".tf-pricing-coach-form");
    if (!btns.length) return;

    function activate(coachId) {
      btns.forEach(function (btn) {
        btn.classList.toggle(
          "is-active",
          btn.getAttribute("data-pricing-coach") === coachId,
        );
      });
      forms.forEach(function (form) {
        form.classList.toggle(
          "tf-pcf--hidden",
          form.id !== "tf-pcf-" + coachId,
        );
      });
      var activeBtn = document.querySelector('[data-pricing-coach="' + coachId + '"]');
      if (activeBtn) {
        var priceEl = document.getElementById("tf-price-amount");
        if (priceEl) {
          var price = activeBtn.getAttribute("data-price");
          if (price) priceEl.textContent = price;
        }
        var taglineEl = document.getElementById("tf-price-tagline");
        if (taglineEl) {
          var tagline = activeBtn.getAttribute("data-tagline");
          if (tagline) taglineEl.textContent = tagline;
        }
      }
    }

    btns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        activate(this.getAttribute("data-pricing-coach"));
      });
    });
  }

  // ============================================================
  // FOUNDRY CORE WAITLIST (Klaviyo Client API)
  // ============================================================
  function initWaitlist() {
    var root = document.getElementById("tf-waitlist");
    if (!root) return;

    var publicKey = root.getAttribute("data-klaviyo-public-key");
    var listId = root.getAttribute("data-klaviyo-list-id");
    if (!publicKey || !listId) return;

    var openBtn = root.querySelector(".tf-waitlist__open");
    var form = root.querySelector(".tf-waitlist__form");
    var input = root.querySelector(".tf-waitlist__input");
    var submitBtn = root.querySelector(".tf-waitlist__submit");
    var errorEl = root.querySelector(".tf-waitlist__error");
    var successEl = root.querySelector(".tf-waitlist__success");
    var emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    function setState(state) {
      root.setAttribute("data-state", state);
      if (state === "idle") {
        openBtn.hidden = false;
        form.hidden = true;
        successEl.hidden = true;
      } else if (state === "open" || state === "submitting" || state === "error") {
        openBtn.hidden = true;
        form.hidden = false;
        successEl.hidden = true;
      } else if (state === "success") {
        openBtn.hidden = true;
        form.hidden = true;
        successEl.hidden = false;
      }
    }

    function showError(msg) {
      errorEl.textContent = msg;
      errorEl.hidden = false;
    }
    function clearError() {
      errorEl.textContent = "";
      errorEl.hidden = true;
    }

    openBtn.addEventListener("click", function () {
      setState("open");
      setTimeout(function () { input.focus(); }, 0);
    });

    input.addEventListener("input", clearError);

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var email = (input.value || "").trim();
      if (!email) { showError("Please enter your email."); return; }
      if (!emailRe.test(email)) { showError("That email address doesn't look right."); return; }

      clearError();
      setState("submitting");
      submitBtn.disabled = true;
      input.disabled = true;
      var originalText = submitBtn.textContent;
      submitBtn.textContent = "\u2026";

      fetch("https://a.klaviyo.com/client/subscriptions/?company_id=" + encodeURIComponent(publicKey), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "revision": "2024-10-15"
        },
        body: JSON.stringify({
          data: {
            type: "subscription",
            attributes: {
              custom_source: "Foundry Core Waitlist",
              profile: {
                data: {
                  type: "profile",
                  attributes: { email: email }
                }
              }
            },
            relationships: {
              list: { data: { type: "list", id: listId } }
            }
          }
        })
      }).then(function (res) {
        if (res.status === 200 || res.status === 202) {
          setState("success");
          return;
        }
        return res.json().catch(function () { return null; }).then(function (body) {
          var detail = body && body.errors && body.errors[0] && body.errors[0].detail;
          submitBtn.disabled = false;
          input.disabled = false;
          submitBtn.textContent = originalText;
          setState("error");
          showError(detail || ("Couldn't sign you up (status " + res.status + "). Try again?"));
        });
      }).catch(function (err) {
        submitBtn.disabled = false;
        input.disabled = false;
        submitBtn.textContent = originalText;
        setState("error");
        showError("Network error \u2014 " + (err && err.message ? err.message : "please try again."));
      });
    });
  }

  // ============================================================
  // INIT
  // ============================================================
  // ============================================================
  // FAQ ACCORDION
  // Plain div + button + hidden panel. We deliberately avoid
  // <details>/<summary> because the host Shopify theme has
  // global rules that absolute-position the panel, breaking
  // document flow regardless of scoped resets.
  // ============================================================
  function initFaq() {
    var lists = document.querySelectorAll("[data-tf-faq]");
    if (!lists.length) return;
    lists.forEach(function (list) {
      var items = list.querySelectorAll(".tf-faq__item");
      items.forEach(function (item) {
        var btn = item.querySelector(".tf-faq__q");
        var panel = item.querySelector(".tf-faq__a");
        if (!btn || !panel) return;
        btn.addEventListener("click", function () {
          var willOpen = !item.classList.contains("is-open");
          // Single-open accordion: collapse any other open item in this list.
          items.forEach(function (other) {
            if (other === item) return;
            if (other.classList.contains("is-open")) {
              other.classList.remove("is-open");
              var otherBtn = other.querySelector(".tf-faq__q");
              var otherPanel = other.querySelector(".tf-faq__a");
              if (otherBtn) otherBtn.setAttribute("aria-expanded", "false");
              if (otherPanel) otherPanel.setAttribute("hidden", "");
            }
          });
          item.classList.toggle("is-open", willOpen);
          btn.setAttribute("aria-expanded", willOpen ? "true" : "false");
          if (willOpen) {
            panel.removeAttribute("hidden");
          } else {
            panel.setAttribute("hidden", "");
          }
        });
      });
    });
  }

  function init() {
    initScrollAnimations();
    initStickyNav();
    bindScrollLinks(document);
    initCoaches();
    initQuiz();
    initPricingTabs();
    initCoachesCarousel();
    initPricingCoachSelector();
    initWaitlist();
    initFaq();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

/* CTA ATTENTION PULSE — mirrors the :hover language (cold-white silver
   gradient on a deep #2e4d70 fill) on every primary / ghost CTA the first
   time it enters the viewport on each scroll-pass. Header CTAs
   (.tf-btn--nav inside .tf-nav) are excluded so the sticky nav button
   never fires. Self-contained so it is independent of the main init(). */
(function () {
  if (typeof window === "undefined") return;
  var HOLD_MS = 900;
  var SELECTOR = ".tf-btn--primary, .tf-btn--ghost";

  function pulse(el) {
    el.classList.add("is-attn");
    window.setTimeout(function () {
      el.classList.remove("is-attn");
    }, HOLD_MS);
  }

  function initPulse() {
    if (!("IntersectionObserver" in window)) return;
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) pulse(entry.target);
        });
      },
      { threshold: 0.6 }
    );
    document.querySelectorAll(SELECTOR).forEach(function (el) {
      if (el.closest(".tf-nav")) return;
      io.observe(el);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initPulse);
  } else {
    initPulse();
  }
})();
